import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Grid,
  Menu,
  ListItemIcon,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { useAuth } from "../../../AuthProvider";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useLocation } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {  IconButton } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2"; 
import axios from "axios";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const Teacherlist = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // const [filteredData1, setFilteredData1] = useState([]);
 
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const { oId,role,pId,userId,board } = useAuth();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const [assignedTeacherIds, setAssignedTeacherIds] = useState([]);

  const [fetchloading, setfetchLoading] = useState(false); // Use only this
 const [loading, setLoading] = useState(true);
    const [tableLoading, settableLoading] = useState(true); 
     const [tableData, setTableData] = useState([]);

     // ✅ States
const [isAvailableLoading, setIsAvailableLoading] = useState(true); // loading for available teachers
const [isAssignedLoading, setIsAssignedLoading] = useState(false); // loading for assigned table

const [availableTeachers, setAvailableTeachers] = useState([]);
const [assignedTeachers, setAssignedTeachers] = useState([]);

 



    const location = useLocation();
  const { rowData, leaveDate } = location.state || {};

   console.log("Selected Row:", rowData);
  console.log("Leave Date:", leaveDate);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

    const [users, setUsers] = useState([]);
        const [selectedUsers, setSelectedUsers] = useState('');
        const isPrincipal = role?.startsWith("PRINCIPAL") || false;
        const UserId = userId || selectedUsers;
      
        useEffect(() => {
          const fetchUsers = async () => {
              try {
                  const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch users');
                  }
                  const data = await response.json();
                  setUsers(data);
                  if (data.length > 0) {
                    setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                }
              } catch (error) {
                  console.error('Error fetching users:', error);
              }
          };
          fetchUsers();
      }, []);

// ✅ Fetch available teachers useEffect

 const fetchAvailableTeachers = async () => {
  if (!UserId || !rowData || !leaveDate || !pId) return;

  const dayName = rowData.dayName?.toUpperCase();
  const timeSlot = rowData.timeSlot;

  setIsAvailableLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/leave/available-teachers/${pId}?dayName=${encodeURIComponent(
        dayName
      )}&timeSlot=${encodeURIComponent(timeSlot)}&date=${leaveDate}`
    );

    const data = await response.json();
    if (Array.isArray(data)) {
      setAvailableTeachers(data);
    } else {
      console.error("Expected an array but got:", data);
      setAvailableTeachers([]);
    }
  } catch (error) {
    console.error("Error fetching available teachers: ", error);
    setAvailableTeachers([]);
  } finally {
    setIsAvailableLoading(false);
  }
};

useEffect(() => {
  fetchAvailableTeachers();
}, [UserId, rowData, leaveDate, pId]);




  const filteredResults = filteredData.filter((row) => {
    if (!searchQuery) return true; // Show all if no search input

    const teacherfirstName = row.teacherFirstName?.toLowerCase() || "";
    const teacherLastName = row.teacherLastName?.toLowerCase() || "";
    const teacherId = row.teacherId?.toLowerCase() || "";
    const fullName = `${teacherfirstName} ${teacherLastName}`;
    const query = searchQuery.toLowerCase();

    return fullName.includes(query) || teacherId.includes(query);
  });

const exportToExcel = () => {
  const processedData = availableTeachers.map(
    (
      {
        employeeId,
        teacherName,
        contact,
        email,
        subject,
      },
      index
    ) => ({
      Sno: index + 1,
      TeacherID: employeeId,
      TeacherName: teacherName,
      ContactNumber: contact,
    //   Email: email?.trim() ? email : "N/A",
      Subjects:
        Array.isArray(subject) && subject.length
          ? subject.join(", ")
          : typeof subject === "string" && subject.trim()
          ? subject
          : "N/A",
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Teachers_List");

  // Add headers
  worksheet.columns = [
    { header: "S.No", key: "Sno", width: 10 },
    { header: "Teacher ID", key: "TeacherID", width: 15 },
    { header: "Teacher Name", key: "TeacherName", width: 25 },
    { header: "Contact Number", key: "ContactNumber", width: 20 },
    // { header: "Email", key: "Email", width: 30 },
    { header: "Subjects", key: "Subjects", width: 40 },
  ];

  // Add data to worksheet
  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Style headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue Header
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Teacher_List.xlsx";
    link.click();
  });

  handleExportClose();
};


  const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Teachers List", 10, 10);

  // Table
  doc.autoTable({
    startY: 20,
    head: [
      [
        "S.No",
        "Teacher ID",
        "Teacher Name",
        "Contact Number",
        // "Email",
        "Subjects",
      ],
    ],
    body: availableTeachers.map((row, index) => [
      index + 1,
      row.employeeId,
      row.teacherName,
      row.contact,
    //   row.email?.trim() ? row.email : "N/A",
      typeof row.subject === "string" && row.subject.trim() ? row.subject : "N/A",
    ]),
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181], // Dark Blue Header
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  doc.save("Teacher_List.pdf");
  handleExportClose();
};


  const exportToJSON = () => {
    const processedData = filteredData.map(
      ({
        teacherId,
        teacherFirstName,
        teacherLastName,
        teacherContactNumber,
        teacherEmailId,
        subject,
      }) => ({
        TeacherID: teacherId,
        TeacherName: `${teacherFirstName} ${teacherLastName}`,
        ContactNumber: teacherContactNumber,
        Email: teacherEmailId,
        Subjects: subject.join(", "),
      })
    );

    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(processedData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "Teacher_List.json";
    link.click();
    handleExportClose();
  };

  const headerStyle = {
    borderRight: "1px solid #ddd",
    padding: "6px",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#fff9c4",
  };

  
//fetch table
const handleAssignTeacher = async (teacherRow) => {
  try {
    if (!teacherRow || !teacherRow.employeeId) {
      toast.error("No valid teacher selected");
      return;
    }

   const queryString = `teacherId=${encodeURIComponent(teacherRow.employeeId)}&dayName=${encodeURIComponent(rowData.dayName)}&period=${encodeURIComponent(rowData.period)}&timeSlot=${encodeURIComponent(rowData.timeSlot)}&romanNumberClass=${encodeURIComponent(rowData.romanNumberClass)}&sections=${encodeURIComponent(rowData.sections)}&date=${encodeURIComponent(leaveDate)}&employeeId=${encodeURIComponent(rowData.teacherId)}`;


    const url = `${baseUrl}/api/lessorPeriod/teacher-assgined-lessorPeriod/${oId}/${pId}?${queryString}`;

    const response = await fetch(url, { method: "POST" });

    if (response.ok) {
      const result = await response.json();
      console.log("✅ Teacher Assigned Successfully:", result);
      
      setAssignedTeacherIds((prev) => [...prev, teacherRow.employeeId]);

      toast.success("Teacher assigned successfully!");

      // ✅ Fetch table with assigned teacherId and day
      fetchAssignedTeachers(rowData.teacherId, rowData.dayName);
    } else {
      toast.error("Failed to assign teacher");
      console.error("❌ API Error:", response.statusText);
    }
  } catch (error) {
    toast.error("Something went wrong!");
    console.error("🚨 Exception during teacher assignment:", error);
  }
};




// Function to handle delete action
const handleDeleteRow = async (lId) => {
  if (!lId) {
    toast.error("Invalid row. Please select a valid row to delete.");
    return;
  }

  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        setLoading(true);
        console.log("Deleting row with ID:", lId);

        const response = await fetch(`${baseUrl}/api/lessorPeriod/delete/${lId}`, {
          method: "DELETE",
        });

        if (!response.ok) {
          throw new Error("Failed to delete the row. Please try again.");
        }

        toast.success("Row deleted successfully!", { autoClose: 1000 });

        // ✅ Re-fetch table data instead of filtering locally
        if (
          rowData?.teacherId &&
          rowData?.dayName &&
          rowData?.timeSlot &&
          leaveDate
        ) {
          await fetchAssignedTeachers(rowData.teacherId, rowData.dayName);
          await fetchAvailableTeachers(); // Add this line
        }

      } catch (error) {
        toast.error(`Error deleting row: ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  });
};



 
// ✅ Fetch assigned teachers for table
const fetchAssignedTeachers = async (teacherId, day) => {
  if (!teacherId || !day) {
    setIsAssignedLoading(false);
    return;
  }

  setIsAssignedLoading(true);
  try {
    const response = await axios.get(
      `${baseUrl}/api/lessorPeriod/getRecentAssginedTeachers/${teacherId}?dayName=${encodeURIComponent(day)}&timeSlot=${encodeURIComponent(rowData.timeSlot)}&date=${encodeURIComponent(leaveDate)}`
    );

    if (Array.isArray(response.data)) {
      setAssignedTeachers(response.data);
    } else {
      setAssignedTeachers([]);
    }
  } catch (error) {
    console.error("Error fetching assigned teachers:", error);
    setAssignedTeachers([]);
  } finally {
    setIsAssignedLoading(false);
  }
};
useEffect(() => {
  if (

    rowData?.teacherId && 
    rowData?.dayName &&
    rowData?.timeSlot &&
    leaveDate
  ) {
    fetchAssignedTeachers(rowData.teacherId, rowData.dayName);
  }
}, [rowData, leaveDate]);


 // Add leaveDate if it can change





  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* cardcontent-1 */}

        <CardContent>
       <Box display="flex" alignItems="center" sx={{ px: 3,marginBottom: 2, marginTop: -3, marginLeft: -3,paddingTop: '10px'}}>
  <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
    <KeyboardBackspaceIcon fontSize="medium" />
  </IconButton>
  <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold' }}>
    Teachers Schedule
  </Typography>
</Box>



        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          flexWrap="wrap"
        >
          {/* Left Section: Search + User Dropdown */}
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
            <TextField
              label="Search by Teacher Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* {isPrincipal && (
              <FormControl style={{ width: "200px" }} size="small">
                <InputLabel>Select Schedule Admin</InputLabel>
                <Select
                  value={selectedUsers}
                  onChange={(e) => setSelectedUsers(e.target.value)}
                  label="Select Schedule Admin"
                >
                  {users.map((user) => (
                    <MenuItem key={user.userId} value={user.userId}>
                      {user.userId} - {user.firstName} {user.lastName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )} */}
          </Box>

          {/* Right Section: Export + Schedule */}
          <Box display="flex" gap={2} alignItems="center" mt={{ xs: 2, sm: 0 }}>
            <Button
              variant="contained"
              onClick={handleExportClick}
              sx={{
                backgroundColor: "#6E69B0",
                color: "white",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#58548E",
                },
              }}
              startIcon={<PresentToAllIcon />}
            >
              Export
            </Button>

            {/* <Button
              variant="contained"
              sx={{
                backgroundColor: "#6E69B0",
                color: "white",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#58548E",
                },
              }}
              onClick={() => navigate("/AddNewClassSchedules")}
            >
              Schedule New Class
            </Button> */}
          </Box>

          {/* Export Menu */}
          <Menu
            anchorEl={exportAnchorEl}
            open={isExportMenuOpen}
            onClose={handleExportClose}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
              },
            }}
          >
            <MenuItem
              onClick={exportToExcel}
              sx={{
                color: "#3f51b5",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f0fe",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#00796b" }}>
                <SimCardDownloadIcon />
              </ListItemIcon>
              <ListItemText
                primary="Excel"
                sx={{ fontWeight: "bold", color: "#00796b" }}
              />
            </MenuItem>

            <MenuItem
              onClick={exportToPDF}
              sx={{
                color: "#d32f2f",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#fdecea",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#d32f2f" }}>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText
                primary="PDF"
                sx={{ fontWeight: "bold", color: "#d32f2f" }}
              />
            </MenuItem>

            {/* <MenuItem
              onClick={exportToJSON}
              sx={{
                color: "#388e3c",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f5e9",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#6a1b9a" }}>
                <FilePresentIcon />
              </ListItemIcon>
              <ListItemText
                primary="JSON"
                sx={{ fontWeight: "bold", color: "#6a1b9a" }}
              />
            </MenuItem> */}
          </Menu>
        </Box>



          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Teacher Id
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      fontSize: "14px",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                    }}
                  >
                    Teacher Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Subject
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Action
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Delete
                  </TableCell> */}
                </TableRow>
              </TableHead>
              {isAvailableLoading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </TableCell> */}

                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
            // ) : filteredResults && filteredResults.length === 0 ? (
            // ) : Array.isArray(filteredResults) && filteredResults.length === 0 ? (
            ) : Array.isArray(availableTeachers) && availableTeachers.length === 0 ? (
                
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {availableTeachers.map((row, index) => (
                    <TableRow
                      key={row.id}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.employeeId}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherName} 
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {Array.isArray(row.subject)
                          ? row.subject.join(", ")
                          : row.subject || "N/A"}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.contact}
                      </TableCell>

                        <TableCell
                        sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "center",
                            fontSize: "14px",
                        }}
                        >
                        <Button
                        variant="contained"
                        onClick={() => handleAssignTeacher(row)}
                        disabled={assignedTeacherIds.includes(row.employeeId)} // disable if assigned
                        sx={{
                            backgroundColor: "#1976d2",
                            margin: "4px",
                            fontSize: "0.6rem",
                            minWidth: "90px",
                            textTransform: "none",
                            "&:hover": {
                            backgroundColor: "#1565c0",
                            },
                            ...(assignedTeacherIds.includes(row.employeeId) && {
                            backgroundColor: "#9e9e9e", // gray out if disabled
                            cursor: "not-allowed",
                            }),
                        }}
                        >
                        {assignedTeacherIds.includes(row.employeeId) ? "Assigned" : "Assign Teacher"}
                        </Button>


                        </TableCell>

                        

                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px", // Slightly more padding for better spacing
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          // Light background to differentiate
                          "&:hover": {
                            backgroundColor: "#f1f1f1", // Slight hover effect on the cell
                          },
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() =>
                            navigate(`/TeacherTimeTable`, {
                              state: { student: row },
                            })
                          }
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.65rem", // Slightly increased font size for better readability
                            padding: "4px 12px", // Adjusted padding for better button size
                            height: "28px", // Slightly increased height for comfort
                            borderRadius: "20px", // Rounded button
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Adds subtle shadow
                            textTransform: "uppercase", // Capitalizes button text for emphasis
                            transition: "all 0.3s ease", // Smooth transition for hover effects
                            "&:hover": {
                              backgroundColor: "#1565c0", // Darker shade on hover
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)", // More shadow on hover
                            },
                          }}
                        >
                         View Time Table
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <ToastContainer position="top-right"autoClose={2000} />

        </CardContent>

        {/* cardcontent-2 */}

<Box sx={{ px: 3 }}>
<CardContent
  sx={{
    backgroundColor: "#f5f5f5",
    boxShadow: "6px 0px 10px -2px rgba(0, 0, 0, 0.4), -6px 0px 10px -2px rgba(0, 0, 0, 0.4)", // Left & right shadows
    borderRadius: 2,
    mt: 2,
    px: 3,
    py: 2,
    pb: 6,  
  }}
>
  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
    Assigned Teachers List
  </Typography>

  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    flexWrap="wrap"
  >
     {/* Table Section */}
      <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        maxHeight: "350px",
        overflow: "auto",
        marginTop: "20px"
      }}
      className="custom-sidebar-scrollbar"
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerStyle}>S.No</TableCell>
            <TableCell sx={headerStyle}>TeacherID</TableCell>
            <TableCell sx={headerStyle}>Weekday</TableCell>
            <TableCell sx={headerStyle}>Period</TableCell>
            <TableCell sx={headerStyle}>Time</TableCell>
            {board === "INTERMEDIATE" && (
            <TableCell sx={headerStyle}>Course</TableCell>
            )}
            <TableCell sx={headerStyle}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
            <TableCell sx={headerStyle}>Section</TableCell>
            <TableCell sx={headerStyle}>Subject</TableCell>
            <TableCell sx={headerStyle}>Action</TableCell>
          </TableRow>
        </TableHead>
    
        {isAssignedLoading ? (
          <TableBody>
            <TableRow>
               <TableCell
                                    colSpan={9}
                                    style={{ textAlign: "center", padding: "20px" }}
                                  >
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      <CircularProgress />
                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                        Loading Data...
                                      </Typography>
                                    </Box>
                                  </TableCell>
            </TableRow>
          </TableBody>
        ) : assignedTeachers.length === 0 ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={9} sx={{ textAlign: "center", padding: "20px" }}>
                No data found
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {assignedTeachers.map((row, index) => (
              <TableRow key={index} sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{index + 1}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.teacherId}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.dayName}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.period ? `Period ${row.period}` : "-"}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.timeSlot}</TableCell>
                {board === "INTERMEDIATE" && (
                 <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.course}</TableCell>                    
                 )}
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.romanNumberClass}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.sections}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.subject ||"N/A"}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>
                {/* <Button
      variant="contained"
      sx={{
        backgroundColor: "#1976d2",
        color: "white",
        marginRight: "5px",
        "&:hover": {
          backgroundColor: "#1565c0",
        },
      }}
      size="small"
    //   onClick={() => handleEditRow(row)} // Pass row data for editing
    >
      Edit
    </Button> */}
    
    
                  <Button
      variant="contained"
      sx={{
        backgroundColor: "#f44336",
        color: "#fff",
        "&:hover": { backgroundColor: "#d32f2f" },
      }}
      size="small"
      onClick={() => handleDeleteRow(row.lId)} // ✅ Use `row.id` as per API data
    >
      Delete
    </Button>
    
    
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>

    
  </Box>
</CardContent>
</Box>



        


      </Card>
    </Box>
  );
};

export default Teacherlist;